export const experience = [
  {
    id: 'powerschool',
    role: 'Software Engineer & AI Innovation Lead',
    company: 'PowerSchool',
    duration: 'March 2024 - Present',
    details: 'Spearheaded AI initiatives to automate DevEx workflows and built a multi-agent orchestrator using LLMs.'
  },
  {
    id: 'accenture',
    role: 'Application Development Associate',
    company: 'Accenture',
    duration: 'June 2021 - March 2024',
    details: 'Led Liferay projects for Lenovo Global Seller Platform. Promoted rapidly for driving significant client value.'
  }
];

export const projects = [
  {
    id: 'church-erp',
    title: 'Multi-Tenant Church ERP',
    summary: 'Enterprise Resource Planning & Financial Portal with multi-tenant architecture and double-entry accounting.',
    tech: ['Java', 'Spring Boot', 'React', 'PostgreSQL', 'Google Cloud Run'],
    details: 'A multi-tenant SaaS application serving dioceses and local churches with strict data isolation. Features 6-tier hierarchical RBAC, dynamic subdomain binding, and automated WhatsApp integrations. Handled massive scaling challenges, security compliance, and financial accuracy.',
    date: '2024',
    showInPortfolio: true,
    showInBlog: true
  },
  {
    id: 'powerschool-ai',
    title: 'Autonomous AI Orchestrator',
    summary: 'A Multi-Agent system automating SDLC for engineering teams.',
    tech: ['Python', 'OpenAI API', 'N8N', 'GitHub Copilot Enterprise'],
    details: 'Designed and deployed a Production-Grade Multi-Agent System within a legacy enterprise environment. Features a Supervisor Agent connected to Jira that delegates tasks to sub-agents, writes code, and enforces standards via a Human-in-the-Loop mechanism.',
    date: '2024',
    showInPortfolio: true,
    showInBlog: true
  },
  {
    id: 'lenovo-platform',
    title: 'Lenovo Global Seller Platform',
    summary: 'Enterprise workflow management and compliance for global ecommerce.',
    tech: ['Java', 'Liferay', 'Javascript', 'HTML', 'CSS'],
    details: 'Developed and maintained the Lenovo Global Seller Platform across multiple regions. Overhauled legacy requirements, executed massive refactoring, and drastically improved code reviews and deployment velocity.',
    date: '2021-2024',
    showInPortfolio: true,
    showInBlog: true
  }
];

export const education = [
  {
    id: 'B-Tech',
    school: 'Karunya Institute of Technology and Sciences',
    year: '2017 - 2021',
    degree: 'B.Tech in Electronics and Communication Engineering',
    details: 'Graduated with strong technical foundation.'
  },
  {
    id: 'MBA',
    school: 'Alagappa University',
    year: '2024 - 2026',
    degree: 'MBA in International Business',
    details: 'Completed with First Class. Bridged technical execution with global business strategy and product management.'
  }
];
